import { useTimeFormatPreference } from '~publish/hooks/useTimeFormatPreference'

export const useTwentyFourHourTimeFormat = (): boolean => {
  const timeFormatPreference = useTimeFormatPreference()
  return timeFormatPreference === '24'
}
